import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            瓜友热议
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            看看其他吃瓜群众都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.badge}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/60">
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}